var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "44px",
    viewBox: "0 0 75 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 29 Copy@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.469631,30.2967358 C38.8572352,22.9154068 42.6601128,14.0673389 47.8766623,7.75877361 C45.3430816,5.66981186 41.7347092,4.31421957 37.7413368,4.31421957 C33.5935633,4.31421957 29.8728993,5.72240804 27.3282899,7.95526502 C32.3954513,14.182455 36.1060894,22.8251001 37.5107378,30.0704729 L37.469631,30.2967358 Z",
    id: "Path",
    fill: "#D3882F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34.199136, 6.444861)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0150390625,0.479319965 C1.1078776,0.226262841 2.2859375,0.0863371366 3.54220052,0.0863371366 C7.21373698,0.0863371366 10.3089444,1.26709076 12.3582673,3.01268873 C11.893059,3.64582773 11.4135471,4.31532115 10.975409,4.98319349 C9.8093804,3.29118409 7.71203125,1.71384178 4.57388021,0.881234222 C2.84539063,0.422754255 1.38359375,0.324508548 0.0150390625,0.479319965 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5167534,33.0644861 C19.3936805,-17.0477713 -15.087882,17.8016681 19.5761545,26.0592694 C2.74744353,31.3268271 12.920868,48.7252487 32.4826779,32.0681356 C17.6702039,56.9421624 -3.86874136,35.0284078 12.6722222,25.9163666 C2.12282114,24.8436028 -5.30046011,9.11535827 5.91166228,2.14189783 C21.294618,-7.42564624 35.785256,17.2409729 37.5167534,33.0644861 Z",
    id: "Path",
    fill: "#186AB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5047222,33.0644861 C55.6277951,-17.0477713 90.1093576,17.8016681 55.4453211,26.0592694 C72.2740321,31.3268271 62.1006076,48.7252487 42.5387977,32.0681356 C57.3512717,56.9421624 78.890217,35.0284078 62.3492534,25.9163666 C72.8996571,24.8436028 80.3219357,9.11535827 69.1098133,2.14189783 C53.7278602,-7.42564624 39.2372222,17.2409729 37.5047222,33.0644861 Z",
    id: "Path",
    fill: "#186AB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eeb22ad15a6d92b81627425680bf5389.svg";
export { ForwardRef as ReactComponent };